import React, { useState, useEffect } from "react";
import "./SearchResult.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Scrollbars } from "react-custom-scrollbars";
import Api from "../../Common/api.jsx";
import { Navigate, Link } from "react-router-dom";
import SkeletonProduct  from "../../Pages/Skeleton/index.jsx";

export default class SearchResult extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.applyFilter = false;
    this.state = {
      filter: "",
      loader : false,
      loader3:false,
      userArray: [],
      featureNftArry: [],
      redirect: null,

      minprice: "",
      maxprice: "",
      showverifiedonly: false,
      searchtext: "a",
      searchfield: null, //"Asset",
      pagesize: 10,
      pagenumber: 1,
    };
  }
  onKeyUp(event) {
    console.log(event);
    if (event.charCode === 13) {
      this.getSearchResult();
    }
  }
  componentDidMount() {
    window.addEventListener("click", () => {
      console.log("in1");
      document.getElementsByClassName("search-autocomplete")[0].style.display =
        "none";
    });
    const search = window.location.search;
    const params = new URLSearchParams(search);
    this.setState(
      {
        searchfield: params.get("tab"),
        searchtext: params.get("search"),
      },
      () => {
        this.getSearchResult();
      }
    );

    this.getNftCollection();
    this.onKeyUp = this.onKeyUp.bind(this);
    this.getUpdatedSearchResult = this.getUpdatedSearchResult.bind(this); //bind the function
    this.updateT(null, null);
  }

  removePrice() {
    this.setState(
      {
        minprice: "",
        maxPrice: "",
      },
      console.log("clear")
    );
  }

  removeShowOnly() {
    this.refs["verifiedCheck"].checked = false;
    this.setState(
      {
        showverifiedonly: false,
      },
      console.log("clear")
    );
  }
  clearAll() {
    this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;

    this.applyFilter = false;
    this.setState(
      {
        status: false,
        minprice: "",
        maxprice: "",
        category_id: null,
        showverifiedonly: false,
        isInvalidUser: false,
        assets: [],
        totalRecords: 0,
      },
      () => {
        this.getSearchResult();
      console.log("clear")
      }
    );
  }

  updateT(tab, search) {
    console.log(tab, search);
    if (tab && search) {
      //this.setState({searchfield: tab,searchtext:search},()=>{this.getSearchResult()});
    }
  }

  setFilterCategoryData(id) {
    this.setState({ category_id: id });
    this.setState({ category_id: id }, () => {
      console.log(this.state.category_id, "category_id");
      this.getSearchResult();
      this.explorrerCollection2(1);
    });
  }

  getSearchResult(tab = null, search = null) {
    this.setState({loader: true});
    if (tab && search) {
      //const search = window.location.search;
      //const params = new URLSearchParams(search);
      //this.setState({searchfield: tab,searchtext:search},console.log("in"));
    } else {
      tab = this.state.searchfield;
      search = this.state.searchtext;
    }
    const api = new Api();
    const obj = {
      minprice: this.state.minprice,
      maxPrice: this.state.maxprice,
      searchtext: search, //this.state.searchtext,
      searchfield: tab, //this.state.searchfield,
      showverifiedonly: this.state.showverifiedonly,
      pagenumber: this.state.pagenumber,
      pagesize: this.state.pagesize,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: obj,
    };
    api
      .post("search_result/", obj)
      .then((response) => {
        console.log(this.state.searchfield);
        if (this.state.searchfield == "Asset") {
          this.setState({ userArray: response.data["assets"] });
          this.setState({loader: false});
        } else if (this.state.searchfield == "Collection") {
          this.setState({ userArray: response.data["collections"] });
          this.setState({loader: false});
        } else if (this.state.searchfield == "User") {
          this.setState({ userArray: response.data["users"] });
          this.setState({loader: false});
        }
      })
      .catch((err) => console.log(err));
    this.applyFilter = true;
  }

  tabActive(tab) {
    this.setState({
      redirect:
        "/SearchResult/?tab=" + tab + "&search=" + this.state.searchtext,
    });
    this.setState(
      { searchfield: tab, searchtext: this.state.searchtext },
      () => {
        this.getSearchResult();
      }
    );
    //this.updateT(tab , this.state.searchtext)
  }

  // callback function used to set the tab value and search value from the search header
  getUpdatedSearchResult(tabValue, searchValue) {
    this.setState(
      {
        searchfield: tabValue,
        searchtext: searchValue,
      },
      () => {
        this.getSearchResult();
      }
    );
    this.getNftCollection();
  }

  getNftCollection() {
    const api = new Api();
    this.setState({loader3: true});
    var parameter = "";

    api
      .get("get_featured_nft_collection/?pagesize=10&pagenumber=1", parameter)
      .then((response) => {
        this.setState({ featureNftArry: response.data });
        this.setState({loader3: false});
      })
      .catch((err) => console.log(err));
  }

  //Filter Code
  showMOreCollection() {
    var pageNumber = this.state.pagenumber + 1;
    this.setState({ pageNumber: pageNumber }, () => {
      this.getSearchResult();
    });
  }
  handleChange(e) {
    console.log(e, e.target.name);
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  }

  handleChangeCheck = (e) => {
    this.setState({ status: e.target.checked });
    console.log(e.target.checked);
  };

  setFilterData(e) {
    this.setState({ showverifiedonly: e.target.checked });
  }

  explorrerCollection() {
    document.body.classList.toggle("filterActive", "filter");
    document
      .querySelector(".filter-button")
      .classList.toggle("active", "filter");
    document
      .querySelector(".filter-list-box-wrap")
      .classList.toggle("filter-open", "filter");
  }
  explorrerCollection2(flag) {
    document.body.classList.remove("filterActive");
    document
      .querySelector(".filter-button")
      .classList.toggle("filter", "active");
    document
      .querySelector(".filter-list-box-wrap")
      .classList.remove("filter-open");

    if (flag == 2) {
      //var x = document.getElementsByClassName("verifiedCheck");
      this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
      //x.checked = false;

      this.applyFilter = false;
      this.setState(
        {
          status: false,
          minprice: "",
          maxPrice: "",
          category_id: null,
          showVerifiedOnly: false,
          assets: [],
          totalRecords: 0,
        },
        () => {
          this.getSearchResult();
          console.log("clear");
        }
      );
    }
  }

  // const [filter, setFilter] = useState(false);
  // useEffect(() => {
  //   document.body.classList.toggle("filterActive", filter);
  //   document.querySelector(".filter-button").classList.toggle("active", filter);
  //   document
  //     .querySelector(".filter-list-box-wrap")
  //     .classList.toggle("filter-open", filter);
  // }, [filter]);
  render = () => {
    if (this.state.redirect) {
      var url = this.state.redirect;
      this.setState({ redirect: null });
      return (
        <Navigate
          // to={"../SearchResult/?tab=Asset&search=" + this.state.value}
          to={url}
          // replace={true}
        />
      );
    }
    return (
      <>
      {/* pass the callback function as a props */}
        <Header onSearchCallBack={this.getUpdatedSearchResult} />
        <div className="exploreCollections">
          <div className="container">
            <div className="section-title">
              <h2>
                results for <label>{this.state.searchtext}</label>{" "}
              </h2>
            </div>
            <div className="filter-wrap">
              <ul className="filter-list">
                <li>
                  <a
                    // href={
                    //   "../SearchResult/?tab=Asset&search=" +
                    //   this.state.searchtext
                    // }
                    className={
                      this.state.searchfield == "Asset" ? "active" : ""
                    }
                    onClick={() => this.tabActive("Asset")}
                  >
                    Items
                  </a>
                </li>
                <li>
                  <a
                    // href={
                    //   "../SearchResult/?tab=Collection&search=" +
                    //   this.state.searchtext
                    // }
                    className={
                      this.state.searchfield == "Collection" ? "active" : ""
                    }
                    onClick={() => this.tabActive("Collection")}
                  >
                    Collections
                  </a>
                </li>
                <li>
                  <a
                    // href={
                    //   "../SearchResult/?tab=User&search=" +
                    //   this.state.searchtext
                    // }
                    className={this.state.searchfield == "User" ? "active" : ""}
                    onClick={() => this.tabActive("User")}
                  >
                    Users
                  </a>
                </li>
              </ul>
              <div className="filter-wrap__btns">
                <button
                  className="filter-button"
                  onClick={() => this.explorrerCollection()} //onClick={() => setFilter(!filter)}
                  //style={{display:this.state.searchfield == '' ? "block": "none"}}
                >
                  <div className="img-box">
                    <i className="material-icons-outlined">filter_list</i>
                  </div>
                  <span>Show Filters</span>
                </button>
                {/* <button className="filter-button">
                <div className="img-box">
                  <i className="material-icons-outlined">sort</i>
                </div>
                <span>Sort</span>
              </button> */}
              </div>
            </div>
            <div className="filter-list-box-wrap">
              {!this.state.loader ? (
              <ul className="explore-nfts">
                {this.state.userArray?.length > 0  ? (this.state.userArray.map((serachresult) => (
                  <li
                    style={{
                      display:
                        this.state.searchfield == "Asset" ? "block" : "none",
                    }}
                  >
                    <a
                      href={
                        "../CollectionDetails?collectionId=" +
                        serachresult.asset_id
                      }
                      className="card"
                    >
                      <div className="card-img">
                        <img src={serachresult.asset_image} alt="discover" />
                        <div className="price">
                          <img src="../images/eth.png" alt="price" /> 0.25
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="artist-block">
                          <div className="media">
                            <div className="media-img">
                              <img
                                src={serachresult.profile_image}
                                alt="artist block"
                              />
                            </div>
                            <div className="media-body">
                              <h4 title={serachresult.asset_name}>
                                <label
                                  style={{
                                    width: 120 + "px",
                                    color: "#ffffff",
                                    whiteSpace: "nowrap",
                                    overflow: " hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {serachresult.asset_name}
                                </label>
                                {/* <div className="img-box">
                                  {serachresult.is_verified ? (
                                    <img
                                      src="../images/verify.png"
                                      alt="verify"
                                    />
                                  ) : (
                                    false
                                  )}
                                </div> */}
                              </h4>
                              <span>{serachresult.user_name}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                )))
                :(
                <li className="no-items-msg" style={{display:this.state.searchfield == "Asset" ? "block" : "none" }}> 
                       <h3>No Items</h3>                     
              </li>)}
                {/* LI END */}
                {/* <li>
                <a href="/" className="card">
                  <div className="card-img">
                    <img src="../images/card1.png" alt="discover" />
                    <div className="price"><img src="../images/eth.png" alt="price" /> 0.25</div>
                  </div>
                  <div className="card-body">
                    <div className="artist-block">
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/artist1.png" alt="artist block" />
                        </div>
                        <div className="media-body">
                          <h4>
                            The Futr Abstr{" "}
                            <div className="img-box">
                              <img src="../images/verify.png" alt="verify" />
                            </div>
                          </h4>
                          <span>Arkhan17</span>
                        </div>
                        <div className="bid-count">1 of 10</div>
                      </div>
                    </div>
                  </div>
                </a>
              </li> */}
                {/* LI END */}
                {/* <li>
                <a href="/" className="card">
                  <div className="card-img">
                    <img src="../images/card1.png" alt="discover" />
                    <div className="price"><img src="../images/eth.png" alt="price" /> 0.25</div>
                  </div>
                  <div className="card-body">
                    <div className="artist-block">
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/artist1.png" alt="artist block" />
                        </div>
                        <div className="media-body">
                          <h4>
                            The Futr Abstr{" "}
                            <div className="img-box">
                              <img src="../images/verify.png" alt="verify" />
                            </div>
                          </h4>
                          <span>Arkhan17</span>
                        </div>
                        <div className="bid-count">1 of 10</div>
                      </div>
                    </div>
                  </div>
                </a>
              </li> */}
                {/* LI END */}
                {/* <li>
                <a href="/" className="card">
                  <div className="card-img">
                    <img src="../images/card1.png" alt="discover" />
                    <div className="price"><img src="../images/eth.png" alt="price" /> 0.25</div>
                  </div>
                  <div className="card-body">
                    <div className="artist-block">
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/artist1.png" alt="artist block" />
                        </div>
                        <div className="media-body">
                          <h4>
                            The Futr Abstr{" "}
                            <div className="img-box">
                              <img src="../images/verify.png" alt="verify" />
                            </div>
                          </h4>
                          <span>Arkhan17</span>
                        </div>
                        <div className="bid-count">1 of 10</div>
                      </div>
                    </div>
                  </div>
                </a>
              </li>  */}
                {/* LI END */}
              </ul>
               ) :  [1, 2, 3, 4,5,6,7,8].map(loading =>(
                <>
                  <div className="skeleton-items" key={loading}>
                  <SkeletonProduct />
                  </div>
                </>
              ))}
              {/* ====================================
                        COLLECTIONS
            ==================================== */}
            {!this.state.loader ? (
              <ul className="explore-nfts collections">
                {this.state.userArray?.length > 0  ? (this.state.userArray.map((serachresultCollection) => (
                  <li
                    style={{
                      display:
                        this.state.searchfield == "Collection"
                          ? "block"
                          : "none",
                    }}
                  >
                    <a
                      href={
                        "../CollectionDetails?collectionId=" +
                        serachresultCollection.collection_id
                      }
                      className="card"
                    >
                      <div className="card-img">
                        <img
                          src={serachresultCollection.collection_image}
                          alt="discover"
                        />
                      </div>
                      <div className="card-body">
                        <div className="artist-block">
                          <div className="media">
                            <div className="media-img">
                              <img
                                src={serachresultCollection.profile_image}
                                alt="artist block"
                              />
                            </div>
                            <div className="media-body">
                              <h4
                                title={serachresultCollection.collection_name}
                              >
                                <label
                                  style={{
                                    width: 120 + "px",
                                    color: "#ffffff",
                                    whiteSpace: "nowrap",
                                    overflow: " hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {serachresultCollection.collection_name}
                                </label>
                                {/* <div className="img-box">
                                  {serachresultCollection.is_verified ? (
                                    <img
                                      src="../images/verify.png"
                                      alt="verify"
                                    />
                                  ) : (
                                    false
                                  )}
                                </div> */}
                              </h4>
                              <span>{serachresultCollection.user_name}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                )))
                :(<li  className="no-items-msg" style={{display:this.state.searchfield == "Collection" ? "block" : "none"}}>
                       <h3>No Items</h3> 
              </li>)}
                {/* LI END */}
                {/* <li>
                <a href="/" className="card">
                  <div className="card-img">
                    <img src="../images/card1.png" alt="discover" />
                  </div>
                  <div className="card-body">
                    <div className="artist-block">
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/artist1.png" alt="artist block" />
                        </div>
                        <div className="media-body">
                          <h4>
                            The Futr Abstr{" "}
                            <div className="img-box">
                              <img src="../images/verify.png" alt="verify" />
                            </div>
                          </h4>
                          <span>100 items</span>
                        </div> 
                      </div>
                    </div>
                  </div>
                </a>
              </li> */}
                {/* LI END */}
              </ul>
              ) :  [1].map(loading =>(
                <>
                  <div className="skeleton-items" key={loading}>
                  <SkeletonProduct />
                  </div>
                </>
              ))}
              {/* ====================================
                        COLLECTIONS
            ==================================== */}
             {!this.state.loader ? (
              <ul className="explore-nfts collections">
                {this.state.userArray?.length > 0  ? (this.state.userArray.map((serachresultUsers) => (
                  <li
                    style={{
                      display:
                        this.state.searchfield == "User" ? "block" : "none",
                    }}
                  >
                    <a
                      href={
                        "../UserProfile?account=" + serachresultUsers.account
                      }
                      className="card"
                    >
                      <div className="card-img">
                        {serachresultUsers.banner_pic ? (
                          <img
                            src={serachresultUsers.banner_pic}
                            alt="artist block"
                          />
                        ) : (
                          <img
                            src="../images/default_banner.png"
                            alt="discover"
                          />
                        )}
                      </div>
                      <div className="card-body">
                        <div className="artist-block">
                          <div className="media">
                            <div className="media-img">
                              {serachresultUsers.profile_pic ? (
                                <img
                                  src={serachresultUsers.profile_pic}
                                  alt="artist block"
                                />
                              ) : (
                                <img
                                  src="../images/default_image.png"
                                  alt="discover"
                                />
                              )}
                            </div>
                            <div className="media-body">
                              <h4 title={serachresultUsers.user_name}>
                                <label
                                  style={{
                                    // width: 120 + "px",
                                    color: "#ffffff",
                                    whiteSpace: "nowrap",
                                    overflow: " hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {serachresultUsers.user_name}
                                </label>
                                <div className="img-box">
                                  {serachresultUsers.is_verified ? (
                                    <img
                                      src="../images/verify.png"
                                      alt="verify"
                                    />
                                  ) : (
                                    false
                                  )}
                                </div>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                )))
                :(<li className="no-items-msg" style={{display:this.state.searchfield == "User" ? "block" : "none"}}>
                         <h3>No Items</h3>            
              </li>)}
                {/* LI END */}
                {/* <li>
                <a href="/" className="card">
                  <div className="card-img">
                    <img src="../images/card1.png" alt="discover" />
                  </div>
                  <div className="card-body">
                    <div className="artist-block">
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/artist1.png" alt="artist block" />
                        </div>
                        <div className="media-body">
                          <h4>
                            The Futr Abstr{" "}
                            <div className="img-box">
                              <img src="../images/verify.png" alt="verify" />
                            </div>
                          </h4> 
                        </div> 
                      </div>
                    </div>
                  </div>
                </a>
              </li> */}
                {/* LI END */}
                {/* <li>
                <a href="/" className="card">
                  <div className="card-img">
                    <img src="../images/card1.png" alt="discover" />
                  </div>
                  <div className="card-body">
                    <div className="artist-block">
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/artist1.png" alt="artist block" />
                        </div>
                        <div className="media-body">
                          <h4>
                            The Futr Abstr{" "}
                            <div className="img-box">
                              <img src="../images/verify.png" alt="verify" />
                            </div>
                          </h4> 
                        </div> 
                      </div>
                    </div>
                  </div>
                </a>
              </li> */}
                {/* LI END */}
                {/* <li>
                <a href="/" className="card">
                  <div className="card-img">
                    <img src="../images/card1.png" alt="discover" />
                  </div>
                  <div className="card-body">
                    <div className="artist-block">
                      <div className="media">
                        <div className="media-img">
                          <img src="../images/artist1.png" alt="artist block" />
                        </div>
                        <div className="media-body">
                          <h4>
                            The Futr Abstr{" "}
                            <div className="img-box">
                              <img src="../images/verify.png" alt="verify" />
                            </div>
                          </h4> 
                        </div> 
                      </div>
                    </div>
                  </div>
                </a>
              </li>  */}
                {/* LI END */}
              </ul>
              ) :  [1,2].map(loading =>(
                <>
                  <div className="skeleton-items" key={loading}>
                  <SkeletonProduct />
                  </div>
                </>
              ))}

              <Scrollbars className="custmScrollbar">
                <div className="filter-box">
                  <div className="filter-title">
                    <h4>Applied Filters</h4>
                    <button
                      className="clear-filter"
                      onClick={() => this.clearAll()}
                    >
                      Clear All
                    </button>
                  </div>
                  <ul className="applied-filter">
                    <li
                      style={{
                        display:
                          this.applyFilter &&
                          this.state.minprice != null &&
                          this.state.minprice != "" &&
                          this.state.maxprice != null &&
                          this.state.maxprice != ""
                            ? "inherit"
                            : "none",
                      }}
                    >
                      <span>
                        {this.state.minprice} To {this.state.maxprice}
                      </span>
                      <a onClick={() => this.removePrice()}>
                        <img
                          onClick={() => this.removePrice()}
                          src="../images/svg/white-cross.svg"
                          alt="clear filter"
                        />
                      </a>
                    </li>
                    {/* li end */}
                    <li
                      style={{
                        display:
                          this.applyFilter &&
                          this.state.showverifiedonly == true
                            ? "inherit"
                            : "none",
                      }}
                    >
                      <span>Show Verified Only</span>
                      <a onClick={() => this.removeShowOnly()}>
                        <img
                          onClick={() => this.removeShowOnly()}
                          src="../images/svg/white-cross.svg"
                          alt="clear filter"
                        />
                      </a>
                    </li>
                  </ul>
                  {/* <div className="filter-title">
                  <h4>Status</h4>
                </div> */}
                  {/* <ul className="filter-check-list">
                  <li>
                    <label htmlFor="buyNow">
                      <input type="checkbox" id="buyNow" hidden defaultChecked />
                      <div className="img-box">
                        <img src="../images/svg/check-white.svg" alt="check" />
                      </div>
                      <span>Buy Now</span>
                    </label>
                  </li>
                  <li>
                    <label htmlFor="onAuction">
                      <input
                        type="checkbox"
                        id="onAuction"
                        hidden
                        defaultChecked
                      />
                      <div className="img-box">
                        <img src="../images/svg/check-white.svg" alt="check" />
                      </div>
                      <span>On Auction</span>
                    </label>
                  </li>
                  <li>
                    <label htmlFor="new">
                      <input type="checkbox" id="new" hidden defaultChecked />
                      <div className="img-box">
                        <img src="../images/svg/check-white.svg" alt="check" />
                      </div>
                      <span>New</span>
                    </label>
                  </li>
                  <li>
                    <label htmlFor="hasOffer">
                      <input
                        type="checkbox"
                        id="hasOffer"
                        hidden
                        defaultChecked
                      />
                      <div className="img-box">
                        <img src="../images/svg/check-white.svg" alt="check" />
                      </div>
                      <span>Has Offer</span>
                    </label>
                  </li>
                </ul> */}
                  <div className="filter-title">
                    <h4>Price (in ETH)</h4>
                  </div>
                  <div className="price-range">
                    <input
                      type="text"
                      name="minprice"
                      id="min"
                      placeholder="min"
                      className="min"
                      value={this.state.minprice}
                      onChange={(e) => {
                        this.handleChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                    <span>to</span>
                    <input
                      type="text"
                      name="maxprice"
                      id="max"
                      placeholder="max"
                      className="max"
                      value={this.state.maxprice}
                      onChange={(e) => {
                        this.handleChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                  {/* <div className="filter-title">
                    <h4>Blockchains</h4>
                  </div> */}
                  {/* <ul className="filter-check-list"> */}
                  {/* <li>
                      <label htmlFor="ethereum">
                        <input
                          type="checkbox"
                          id="ethereum"
                          hidden
                          defaultChecked
                        />
                        <div className="img-box">
                          <img
                            src="../images/svg/check-white.svg"
                            alt="check"
                          />
                        </div>
                        <div className="icon">
                          <img src="../images/coin/eth.png" alt="Verify" />
                        </div>
                        <span>Ethereum</span>
                      </label>
                    </li> */}
                  {/* <li>
                      <label htmlFor="polygon">
                        <input
                          type="checkbox"
                          id="polygon"
                          hidden
                          defaultChecked
                        />
                        <div className="img-box">
                          <img
                            src="../images/svg/check-white.svg"
                            alt="check"
                          />
                        </div>
                        <div className="icon">
                          <img src="../images/coin/poly.png" alt="Verify" />
                        </div>
                        <span>Polygon</span>
                      </label>
                    </li> */}
                  {/* <li>
                      <label htmlFor="solana">
                        <input
                          type="checkbox"
                          id="solana"
                          hidden
                          defaultChecked
                        />
                        <div className="img-box">
                          <img
                            src="../images/svg/check-white.svg"
                            alt="check"
                          />
                        </div>
                        <div className="icon">
                          <img src="../images/coin/sola.png" alt="Verify" />
                        </div>
                        <span>Solana</span>
                      </label>
                    </li> */}
                  {/* </ul> */}
                  <div className="filter-title">
                    <h4>Verification</h4>
                  </div>
                  <ul className="filter-check-list">
                    <li>
                      <label htmlFor="verified">
                        <input
                          type="checkbox"
                          id="verified"
                          ref="verifiedCheck"
                          hidden
                          //defaultChecked
                          onChange={(e) => this.setFilterData(e)}
                        />
                        <div className="img-box">
                          <img
                            src="../images/svg/check-white.svg"
                            alt="check"
                          />
                        </div>
                        <div className="icon">
                          <img src="../images/verify.png" alt="Verify" />
                        </div>
                        <span>Show only verified</span>
                      </label>
                    </li>
                  </ul>
                  <div className="filter-btn-wrap">
                    <button
                      onClick={() => this.setFilterCategoryData()} //this.getSearchResult()}
                      className="button"
                    >
                      Apply
                    </button>
                    <button
                      className="button purple-outline"
                      onClick={() => this.explorrerCollection2()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Scrollbars>
            </div>
            <div
              style={{
                display:
                  this.state.pagenumber >= 2 || this.state.userArray.length == 0
                    ? "none"
                    : "block",
              }}
            >
              <div className="button-wrap">
                <a
                  className="button purple-outline"
                  onClick={() => this.showMOreCollection()}
                >
                  Show More
                </a>
              </div>
            </div>
          </div>
        </div>
        <section className="featured-nft">
          <div className="container">
            <div className="section-title">
              <h2>Collection Featured NFTs</h2>
            </div>
            <ul className="nft-list">
            {!this.state.loader3 ? (
              <ul className="nft-list">
                {this.state.featureNftArry
                  .slice(0, 3)
                  .map((featureNftCollection) => (
                    <li>
                      <div className="img-group">
                        <div className="left-img">
                          {featureNftCollection.assets
                            .slice(0, 1)
                            .map((featureNftImg, i) => (
                              <a
                                href={
                                  "../NftDetails/?assetId=" +
                                  featureNftImg.asset_id
                                }
                              >
                                <img src={featureNftImg.image_loc} alt="Img" />
                              </a>
                            ))}
                        </div>
                        <ul className="right-img">
                          {featureNftCollection.assets
                            .slice(0, 3)
                            .map((featureNftImg, i) => (
                              <li>
                                <a>
                                  <img
                                    src={featureNftImg.image_thumbnail}
                                    alt="Img"
                                  />
                                </a>
                              </li>
                            ))}
                        </ul>
                      </div>
                      <div className="title-block">
                        <h2>{featureNftCollection.collection_name}</h2>
                        <div className="artist">
                          <div className="img-box">
                            <img
                              src={featureNftCollection.user_profile_pic}
                              alt="Artist"
                            />
                          </div>
                          <div className="name">
                            {featureNftCollection.created_by}
                          </div>
                        </div>
                        <a href="/" className="button outline total-item">
                          {featureNftCollection.num_of_asset}
                        </a>
                      </div>
                    </li>
                  ))}
              </ul>
              ) :  [1,2,3,].map(loading =>(
                <>
                  <div className="skeleton-items" key={loading}>
                  <SkeletonProduct />
                  </div>
                </>
              ))}
              {/* <li>
                <div className="img-group">
                  <div className="left-img">
                    <img src="../images/card1.png" alt="Img" />
                  </div>
                  <ul className="right-img">
                    <li>
                      <img src="../images/card2.png" alt="Img" />
                    </li>
                    <li>
                      <img src="../images/card3.png" alt="Img" />
                    </li>
                    <li>
                      <img src="../images/card4.png" alt="Img" />
                    </li>
                  </ul>
                </div>
                <div className="title-block">
                  <h2>Amazing Collection</h2>
                  <div className="artist">
                    <div className="img-box">
                      <img src="../images/artist1.png" alt="Artist" />
                    </div>
                    <div className="name">Arkhan17</div>
                  </div>
                  <a href="/" className="button outline total-item">
                    Total 54 Items
                  </a>
                </div>
              </li> */}
              {/* LI END */}
              {/* <li>
                <div className="img-group">
                  <div className="left-img">
                    <img src="../images/card1.png" alt="Img" />
                  </div>
                  <ul className="right-img">
                    <li>
                      <img src="../images/card2.png" alt="Img" />
                    </li>
                    <li>
                      <img src="../images/card3.png" alt="Img" />
                    </li>
                    <li>
                      <img src="../images/card4.png" alt="Img" />
                    </li>
                  </ul>
                </div>
                <div className="title-block">
                  <h2>Amazing Collection</h2>
                  <div className="artist">
                    <div className="img-box">
                      <img src="../images/artist1.png" alt="Artist" />
                    </div>
                    <div className="name">Arkhan17</div>
                  </div>
                  <a href="/" className="button outline total-item">
                    Total 54 Items
                  </a>
                </div>
              </li> */}
              {/* LI END */}
              {/* <li>
                <div className="img-group">
                  <div className="left-img">
                    <img src="../images/card1.png" alt="Img" />
                  </div>
                  <ul className="right-img">
                    <li>
                      <img src="../images/card2.png" alt="Img" />
                    </li>
                    <li>
                      <img src="../images/card3.png" alt="Img" />
                    </li>
                    <li>
                      <img src="../images/card4.png" alt="Img" />
                    </li>
                  </ul>
                </div>
                <div className="title-block">
                  <h2>Amazing Collection</h2>
                  <div className="artist">
                    <div className="img-box">
                      <img src="../images/artist1.png" alt="Artist" />
                    </div>
                    <div className="name">Arkhan17</div>
                  </div>
                  <a href="/" className="button outline total-item">
                    Total 54 Items
                  </a>
                </div>
              </li> */}
              {/* LI END */}
            </ul>
          </div>
        </section>
        <Footer />
      </>
    );
  };
}
